// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jyIu","selected":"styles_selected__1tWa4"};